export default function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_isObject.js
// module id = 405
// module chunks = 1